import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent, CardHeader } from "@/components/ui/card";

interface RatioCardSkeletonProps {
  count?: number;
}

export function RatioCardSkeleton({ count = 3 }: RatioCardSkeletonProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {[...Array(count)].map((_, i) => (
        <Card key={i} className="border-2">
          <CardHeader>
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-28 animate-shimmer" />
              <Skeleton className="h-4 w-4 rounded-full animate-shimmer" />
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-baseline gap-2">
              <Skeleton className="h-10 w-20 animate-shimmer" />
              <Skeleton className="h-4 w-16 animate-shimmer" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-2 w-full animate-shimmer" />
              <div className="flex justify-between">
                <Skeleton className="h-3 w-10 animate-shimmer" />
                <Skeleton className="h-3 w-10 animate-shimmer" />
              </div>
            </div>
            <Skeleton className="h-4 w-full animate-shimmer" />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
